module.exports = __webpack_public_path__ + "static/media/tint_car_2.11030c29.svg";